<template>
  <v-autocomplete
    v-model="internalVars"
    :items="allAvailableSceneData"
    item-title="name"
    item-value="name"
    return-object
    :loading="loading"
    :label="label"
    :hint="hint" />
  <SceneDataItems
    v-if="internalVars"
    style="overflow: visible"
    :realtime_mode="false"
    :currentObj="internalVarsSceneDataObj"
    :resetFunc="false"
    :breadcrumbs="false"
    :hide_activate_controls="true"
    :hideicons="true"
    :createOrDeleteSceneData="false"
    :openSceneOptions="false"
    :safeTemplates="false"
    :hide_pin_controls="true"
    :disable_tabbing="true"
    :disableFiltering="true"
    :readOnlyMode="false" />
  <v-checkbox
    label="Pinned"
    persistent-hint
    v-if="internalVars"
    v-model="internalVars.pinned"
    hint="If pinned enabled, value will be maintained even after scene change"></v-checkbox>
</template>
<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { $http } from '@/stores/http.js';
import SceneDataItems from './SceneDataItems.vue';

const props = defineProps({
  vars: {
    type: Object,
    default: () => undefined,
  },
  label: {
    type: String,
    default: '',
  },
  hint: {
    type: String,
    default: '',
  },
  allVars: {
    type: Array,
    default: () => [],
  },
  index: {
    type: Number,
    default: 0,
  },
});
const internalVars = ref(undefined);
const loading = ref(false);
const allAvailableSceneData = ref([]);

const internalVarsSceneDataObj = computed(() => {
  let temp = {};
  temp[internalVars.value.name] = internalVars.value;
  return temp;
});
watch(
  internalVars,
  (newValue) => {
    props.allVars[props.index]['value'] = newValue;
  },
  { deep: true }
);
onMounted(async () => {
  // get_all_available_scene_data
  loading.value = true;
  try {
    allAvailableSceneData.value = Object.values(
      JSON.parse(
        await $http('GET', '/dynamic_engine/get_all_available_scene_data')
      )
    );
  } catch (error) {
    console.error('Error fetching scene data:', error);
    allAvailableSceneData.value = [];
  }
  loading.value = false;
  internalVars.value = props.allVars[props.index]['value'] || undefined;
});
</script>
